<template>
  <div class="login-wrapper cool-border">
    <el-form
      v-if="status === statusSwitch.forgetPassword"
      :model="forgetPasswordVerifaction"
      class="login-info"
      label-width="80px"
      ref="resetPasswordVerifatcion"
    >
      <div class="login-info-title">
        Reset Password
      </div>
      <el-form-item
        style="margin-top: 96px"
        label="Email"
        :prop="'email'"
        :rules="stringRule('email')"
      >
        <el-input
          v-model="forgetPasswordVerifaction.email"
          placeholder="please input your email"
        ></el-input>
      </el-form-item>
      <div class="login-info-switch login-theme-font">
        <div @click="setPageStatus(statusSwitch.login)" class="pointer">
          switch to login
        </div>
      </div>
      <div class="login-info-option">
        <el-button
          type="primary"
          class="login-info-option-login"
          @click="sendForgetPassword()"
          ref="emailButton"
          >Submit</el-button
        >
      </div>
    </el-form>
    <el-form
      v-else
      :model="userLoginInfo"
      class="login-info "
      label-width="100px"
      ref="loginForm"
    >
      <div class="login-info-title">
        <div>
          Login
        </div>
      </div>
      <el-form-item
        style="margin-top: 96px"
        label="Email"
        :prop="'email'"
        :rules="stringRule('email')"
      >
        <el-input
          class="login-info-input"
          v-model="userLoginInfo.email"
          placeholder="please input your email"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="Password"
        :prop="'password'"
        :rules="stringRule('Password')"
      >
        <el-input
          class="login-info-input"
          v-model="userLoginInfo.password"
          placeholder="please input your passsword"
          show-password
        ></el-input>
      </el-form-item>
      <div class="login-info-switch login-theme-font">
        <div
          @click="setPageStatus(statusSwitch.forgetPassword)"
          class="pointer"
        >
          forget password?
        </div>
      </div>
      <div class="login-info-option">
        <el-button
          @click="loginWithUserServer()"
          class="login-info-option-login"
          >Login</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MixFormRule from "@/components/mixins/formRule";
export default {
  name: "login",
  mixins: [MixFormRule],
  data() {
    return {
      statusSwitch: {
        login: 0,
        forgetPassword: 1,
      },
      status: 0,
      userLoginInfo: {
        email: "",
        password: "",
        service: "RichMedia",
      },
      forgetPasswordVerifaction: {
        email: "",
      },
    };
  },
  methods: {
    ...mapActions({
      init: "init",
      login: "user/login",
      sendEmailToResetPassword: "user/sendEmailToResetPassword",
    }),
    async loginWithUserServer() {
      this.init();
      try {
        let res = await this.$refs.loginForm.validate();
        await this.login(this.userLoginInfo);
        const auth = Vue.prototype.$cookies.get("auth");
        if (auth) {
          this.$router.push("/");
        }
      } catch (e) {
        console.error(e);
        Vue.prototype.$notify.error({
          title: "Error",
          message: e.response.data.message,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
    setPageStatus(data) {
      this.status = data;
    },
    afterSendEmailDisabledButtonForSeconds(seconds) {
      this.$nextTick(() => {
        const vm = this;
        vm.$refs.emailButton.disabled = true;
        setTimeout(function() {
          vm.$refs.emailButton.disabled = false;
        }, seconds * 1000);
      });
    },
    async sendForgetPassword() {
      try {
        let res = await this.$refs.resetPasswordVerifatcion.validate();
        let obj = {
          email: this.forgetPasswordVerifaction.email,
          link: `${config.dashboard_domain}/login/reset_password`,
        };
        let emailRes = await this.sendEmailToResetPassword(obj);
        Vue.prototype.$notify.success({
          title: "Send email",
          message:
            "We have send an email to you. Please to check your email. If you want to resend again please wait for 10 seconds",
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
        this.afterSendEmailDisabledButtonForSeconds(10);
      } catch (e) {
        Vue.prototype.$notify.error({
          title: "Error",
          message: e.response.data.msg,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
      }
    },
  },
};
</script>
<style lang="sass" scoped>
@keyframes animatedgradient
  0%
    background-position: 0% 50%
  50%
    background-position: 100% 50%
  100%
    background-position: 0% 50%
.login-theme
  &-font
    color: $color-blue

.login-wrapper
  .login-info
    width: 400px
    padding: 16px
    z-index: 1
    background: white
    &-switch
      font-size: 14px
      text-align: right
      display: flex
      justify-content: flex-end
      .pointer
        cursor: pointer
    &-title
      margin: 4px 0px 24px
      display: flex
      justify-content: center
      color: $color-blue
      font-size: 24px
    &-option
      margin-top: 12px
      display: flex
      justify-content: flex-end
      &-login
        width:100%
        background-color: $color-blue
        color: white
        margin-top: 30px
    ::v-deep .el-form-item__label
      text-align: left
    ::v-deep .el-form-item__error
      margin-left: 16px
  h1
    color: $color-blue
    text-align: center
  .btn
    position: relative
    display: block
    border: none
    cursor: pointer
    outline: none
    left: 50%
    transform: translateX(-50%)
  .login-btn
    font-size: 18px
    font-weight: 400
    color: $color-white
    background-color: $color-blue
    border-radius: 30px
    padding: 10px
    text-align: center
    width: 150px
    text-decoration: none
</style>
